import * as React from "react";
import {isEmpty as _isEmpty} from "lodash"
import TextInput from "../TextInput";
import {PrescriptionItemFitnessGuideline} from "../../models/IFitnessPrescription";

interface MindfulnessPlanGuidelinesItemEditorProps {
    item: PrescriptionItemFitnessGuideline,
    onDataChange: (update: PrescriptionItemFitnessGuideline) => void,
    getGuidelineMeta: () => any
}

export default class MindfulnessPlanGuidelinesItemEditor extends React.Component<MindfulnessPlanGuidelinesItemEditorProps> {

    onGuidelinesChange = (event: any) => {
        let updatedGuideline = {...this.props.item, guideline: event.target.value, meta: this.props.getGuidelineMeta()};
        this.props.onDataChange(updatedGuideline);
    }

    render () {
        let disabledClass = !_isEmpty(this.props.item.meta) ? "disable" : "";
        return (
            <div className={"mind-guideline-input-container"}>
                <TextInput name="mind-plan-guideline" value={this.props.item || ""} onChange={this.onGuidelinesChange} placeholder={"Guidelines"} />
            </div>
        )
    }
}